var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationCampaigns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 462,
    height: 320,
    fill: "none",
    viewBox: "0 0 462 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4EEF7",
    d: "M461.684 294.443H.059s-4.316-47.958 60.705-43.878c0 0 1.696-70.859 58.507-57.965 0 0 9.944-29.251 35.151-11.123 0 0 45.48-109.502 134.128-50.998 8.672 5.696 23.897 43.108 14.261 65.431 0 0 40.855-16.55 51.069 27.174 15.918 68.087 48.641 16.396 80.862 36.873 32.183 20.437 26.942 34.486 26.942 34.486z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M393.078 310.069s14.684-33.794 32.375-37.989c2.814-.655 5.512 1.578 5.319 4.426-.385 6.158-5.666 18.59-32.414 39.336l-5.28-5.773z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M395.121 312.379c.231-.308 32.106-37.643 32.106-37.643-6.822 9.584-31.258 37.835-31.528 38.143l-.578-.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M387.913 306.259s3.585-42.338 21.314-53.462c2.814-1.77 6.591-.307 7.439 2.887 1.85 6.89.694 22.401-20.89 54.924l-7.863-4.349z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M390.996 308.03c.155-.424 21.16-52.962 21.16-52.962-3.893 12.971-20.196 52.885-20.35 53.27l-.81-.308z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M455.44 320s-10.33-28.906-35.961-17.59c0 0-10.83 4.927-22.663-7.39 0 0-21.93-28.289-43.09-18.936 0 0-10.33 3.925-15.764 23.132 0 0-27.095-1.001-30.526 20.668L455.44 320z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M79.611 300.216s-15.032-33.639-6.244-49.497c1.388-2.54 4.856-3.002 6.86-.924 4.279 4.465 9.906 16.705 7.17 50.421H79.61z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.733 300.255c-.039-.384-6.167-49.073-6.167-49.073 2.467 11.469 6.86 48.573 6.9 48.958l-.733.115z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M70.553 306.606s-37.155-34.14-34.65-58.889c.386-3.926 4.472-6.389 8.133-4.85 7.786 3.272 21.507 15.666 36.346 59.505l-9.829 4.234z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74.485 304.989L40.182 246.64c9.327 13.086 34.92 57.387 35.228 57.811l-.925.538z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear)",
    d: "M21.836 319.73s12.719-35.41 44.17-21.515c0 0 13.297 6.043 27.827-9.045 0 0 26.903-34.717 52.919-23.248 0 0 12.719 4.85 19.349 28.406 0 0 33.262-1.194 37.501 25.364l-181.766.038z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear)",
    d: "M95.336 319.654s12.719-30.792 33.263-18.129c0 0 8.479 9.661 18.153 1.194 0 0 17.537-23.556 37.502-15.088 19.965 8.467 27.211 32.023 27.211 32.023H95.336z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear)",
    d: "M57.68 146.066c-2.852 0-5.203 2.348-5.203 5.196h-1.156c0-3.503 2.852-6.351 6.36-6.351 3.507 0 6.36 2.848 6.36 6.351h-1.157c0-2.848-2.351-5.196-5.203-5.196z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear)",
    d: "M122.239 36.256l1.234.346c1.426-1.616 3.661-2.386 5.897-1.77 3.083.847 4.894 4.041 4.047 7.082-.848 3.04-4.047 4.888-7.092 4.041-2.043-.577-3.546-2.194-4.047-4.118l-1.272-.347c.424 2.58 2.312 4.812 5.01 5.581 3.7 1.001 7.516-1.154 8.518-4.85 1.002-3.694-1.156-7.505-4.856-8.505-2.891-.77-5.781.346-7.439 2.54z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear)",
    d: "M121.083 222.698c-.886.616-2.004.77-3.045.424l-.694-.231c-.732-.231-1.503-.116-2.119.346-.617.462-.964 1.155-.926 1.924.039 1.155-.539 2.233-1.464 2.887-.925.654-2.12.847-3.199.462l-.694-.231c-.694-.231-1.426-.154-2.004.231-.617.385-1.002 1.001-1.079 1.732l-1.157-.115c.116-1.078.694-2.002 1.581-2.579.925-.578 2.004-.693 3.044-.347l.694.231c.733.27 1.503.154 2.12-.308.617-.461.964-1.154.964-1.924-.039-1.155.501-2.194 1.426-2.848.925-.693 2.081-.847 3.16-.501l.694.231c.694.231 1.465.116 2.081-.308.617-.423.964-1.116.964-1.847v-.308c0-1.116.539-2.117 1.426-2.771.886-.655 2.043-.847 3.083-.501l-.347 1.117c-.693-.231-1.464-.116-2.081.346-.617.423-.963 1.116-.963 1.847v.308c0 1.117-.54 2.156-1.465 2.81.039-.115.039-.077 0-.077z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear)",
    d: "M401.48 136.828c-2.852 0-5.203-2.348-5.203-5.196h-1.156c0 3.502 2.852 6.351 6.359 6.351 3.508 0 6.36-2.849 6.36-6.351h-1.157c0 2.848-2.351 5.196-5.203 5.196z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear)",
    d: "M364.402 236.708h-17.151l8.865-13.587 8.286 13.587zm-14.415-1.501h11.756l-5.666-9.315-6.09 9.315z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear)",
    d: "M370.145 44.262c-.963.5-2.042.539-3.045.116l-.655-.308c-.694-.308-1.464-.27-2.12.115-.655.385-1.079 1.04-1.117 1.81-.116 1.115-.733 2.155-1.735 2.732-1.002.577-2.197.616-3.237.115l-.656-.307c-.655-.308-1.387-.308-2.042.038-.656.308-1.08.924-1.234 1.617l-1.117-.231c.231-1.04.886-1.925 1.85-2.425.963-.462 2.081-.5 3.044-.039l.656.308c.693.347 1.503.308 2.158-.077s1.079-1.039 1.156-1.809c.116-1.154.733-2.117 1.696-2.694.964-.577 2.159-.654 3.199-.192l.655.307c.694.308 1.465.27 2.12-.115.656-.385 1.08-1 1.157-1.77l.038-.308c.116-1.117.732-2.079 1.696-2.618.964-.577 2.12-.616 3.122-.192l-.463 1.078c-.693-.308-1.426-.231-2.081.115-.655.385-1.04 1-1.156 1.732l-.039.308c-.115 1.116-.771 2.078-1.734 2.617-.039.077-.077.077-.116.077z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear)",
    d: "M133.262 104.269h31.181c1.272 0 2.351 1.039 2.351 2.347v20.977c0 1.27-1.04 2.348-2.351 2.348h-2.659v9.43l-9.443-9.43h-19.079c-1.272 0-2.351-1.039-2.351-2.348v-20.977c0-1.308 1.079-2.347 2.351-2.347z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear)",
    d: "M149.103 113.158h-31.181c-1.271 0-2.351 1.039-2.351 2.348v20.977c0 1.27 1.041 2.348 2.351 2.348h7.092v9.429l9.443-9.429h14.646c1.272 0 2.351-1.04 2.351-2.348v-21.015c0-1.271-1.04-2.31-2.351-2.31z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124.05 128.016c1.342 0 2.429-1.086 2.429-2.425 0-1.339-1.087-2.425-2.429-2.425-1.341 0-2.428 1.086-2.428 2.425 0 1.339 1.087 2.425 2.428 2.425zM133.378 128.016c1.341 0 2.428-1.086 2.428-2.425 0-1.339-1.087-2.425-2.428-2.425s-2.428 1.086-2.428 2.425c0 1.339 1.087 2.425 2.428 2.425zM142.936 128.016c1.342 0 2.429-1.086 2.429-2.425 0-1.339-1.087-2.425-2.429-2.425-1.341 0-2.428 1.086-2.428 2.425 0 1.339 1.087 2.425 2.428 2.425z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear)",
    d: "M298.375 94.866v18.86c0 2.655 2.158 4.811 4.818 4.811h30.371c2.66 0 4.818-2.156 4.818-4.811v-18.86c0-2.656-2.158-4.811-4.818-4.811h-30.371c-2.66 0-4.818 2.155-4.818 4.81z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M328.835 97.343l-.001-.01-.001-.015c-.002-.023-.007-.046-.014-.069-.001-.003 0-.006-.002-.009l-.003-.004c-.009-.024-.022-.047-.038-.068l-.011-.014c-.015-.018-.033-.035-.052-.05-.002 0-.004-.002-.006-.004-.021-.014-.045-.025-.07-.033l-.016-.006c-.026-.008-.053-.012-.08-.012h-19.372c-.027 0-.054.004-.08.012l-.017.005c-.024.009-.048.02-.069.034l-.006.005c-.019.014-.037.03-.052.05l-.011.013c-.016.02-.029.044-.039.068l-.002.004-.002.01c-.007.022-.012.045-.014.068l-.001.016-.001.009v13.4l.001.011.003.032.005.026.009.03.009.023.016.029.013.02.021.026.017.017.01.011.008.005c.023.018.049.033.076.044l.019.006c.026.008.054.013.082.014l.006.001h19.37l.006-.001c.028-.001.056-.006.082-.014l.017-.006c.028-.011.053-.026.077-.044l.008-.005.01-.011.017-.017.021-.026.013-.02c.005-.009.011-.019.015-.029.004-.008.007-.015.009-.023l.01-.03.004-.026.004-.032.001-.011.001-13.4zm-13.046 6.08l2.873 2.47c.054.046.122.071.193.071.07 0 .138-.025.192-.071l2.873-2.47 5.982 7.025h-18.095l5.982-7.025zm-6.325 6.52V97.985l5.879 5.054-5.879 6.904zm12.903-6.904l5.878-5.054v11.958l-5.878-6.904zm5.378-5.402l-5.98 5.142-.004.003-.003.003-2.903 2.496-2.904-2.496-.003-.003-.003-.003-5.981-5.142h17.781z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear)",
    d: "M200.172 185.173c-.231-.885-.578-1.732-1.002-2.541l.887-2.039-3.045-2.964-2.043.885c-.809-.423-1.58-.808-2.544-1.001l-.732-2.117h-4.278l-.81 2.117c-.886.231-1.734.578-2.544 1.001l-2.042-.885-2.968 2.964.886 2.039c-.424.809-.809 1.579-1.002 2.541l-2.12.808v4.272l2.12.809c.232.885.578 1.732 1.002 2.54l-.886 2.04 3.045 2.964 2.043-.886c.809.424 1.58.809 2.543 1.001l.81 2.117h4.201l.809-2.117c.887-.231 1.735-.577 2.544-1.001l2.043.886 3.045-2.964-.887-2.04c.424-.808.81-1.578 1.002-2.54l2.12-.809v-4.272l-2.197-.808zm-10.676 8.121c-2.891 0-5.242-2.309-5.242-5.235 0-2.886 2.313-5.234 5.242-5.234s5.242 2.309 5.242 5.234c-.039 2.887-2.351 5.235-5.242 5.235z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear)",
    d: "M314.952 158.037c-.116-.423-.27-.847-.501-1.27l.424-1.001-1.503-1.462-1.002.423c-.386-.231-.81-.385-1.272-.5l-.347-1.039h-2.12l-.385 1.039c-.424.115-.848.269-1.272.5l-1.003-.423-1.464 1.462.424 1.001c-.231.385-.386.808-.501 1.27l-1.041.385v2.117l1.041.385c.115.423.27.847.501 1.27l-.424 1.001 1.503 1.462 1.002-.423c.386.231.81.385 1.272.5l.385 1.039h2.082l.385-1.039c.424-.115.848-.269 1.272-.5l1.002.423 1.503-1.462-.424-1.001c.232-.385.386-.808.502-1.27l1.04-.385v-2.117l-1.079-.385zm-5.28 4.042c-1.426 0-2.583-1.155-2.583-2.579 0-1.424 1.157-2.579 2.583-2.579 1.426 0 2.582 1.155 2.582 2.579 0 1.424-1.156 2.579-2.582 2.579z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC0BF",
    d: "M234.398 225.008l-10.059 8.583-2.082 1.732-7.477-8.776 5.049-5.003 5.704-5.658 8.865 9.122z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear)",
    d: "M208.844 228.934l7.169-3.772s1.311 7.775 7.94 8.737l3.777 22.285c.193 1.232-1.387 1.886-2.081.847l-17.575-24.941c-.771-1.039-.424-2.54.77-3.156z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC0BF",
    d: "M257.793 265.615l-1.927 12.894-.424 2.848-11.447-1.694.617-8.082.501-7.044 12.68 1.078z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear)",
    d: "M241.104 285.36l2.93-7.544s6.089 5.004 11.717 1.386l17.498 14.318c.963.77.193 2.309-1.002 2.001l-29.639-7.312c-1.272-.27-2.005-1.617-1.504-2.849z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC0BF",
    d: "M248.119 29.52c4.086 15.243-8.711 12.972-9.597 12.78h-.039l-.038 4.503-.077 10.969-11.948 1.963-.155-23.67-6.744-10.316 5.665-9.468 11.101-5.62 10.29 6.004c0 4.658 4.163 11.393 4.163 11.393l-2.621 1.463z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFA3B2",
    d: "M234.398 225.008l-10.06 8.583-4.509-12.047 5.704-5.658 8.865 9.122zM257.793 265.615l-1.927 12.894-11.254-6.928.501-7.044 12.68 1.078z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear)",
    d: "M244.188 120.202s27.905 22.478 41.742 35.757c18.192 17.435-1.234 25.518-50.491 81.982l-15.571-16.974 39.93-42.377-15.61-58.388z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear)",
    d: "M277.836 173.432l-12.488 102.42-21.623-4.734 5.088-85.908s-11.332-9.738-22.547-21.901c-11.062-12.008-22.008-26.403-22.008-36.333l35.536-11.278 9.019 12.702 27.365 38.527c1.349 1.886 1.927 4.234 1.658 6.505z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC0BF",
    d: "M282.499 44.878l-4.741 3.772 1.388 34.756c.424 2.964-2.544 5.273-5.319 4.157l-6.783-3.541-9.405-4.888 2.582-16.859 7.015 5.427 1.156.886 3.277-22.594-1.85-3.733c-.54-1.116-.077-2.463 1.04-3.002l1.426-.616 8.48-1.155c.809-.115 1.58.462 1.657 1.309l.54 4.811c.115.462-.077.962-.463 1.27z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFA3B2",
    d: "M267.236 67.664l-.231 16.32-9.366-4.888 2.582-16.859 7.015 5.427z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC0BF",
    d: "M200.673 52.345v16.281l-13.258-1.732-8.75-1.154c-2.158-.27-3.892-1.886-4.355-3.965l-9.173-40.952c-2.39-1.424-3.315-4.735-3.315-4.735l-4.278-3.771c-1.888-2.348.964-2.849.964-2.849-1.426-3.772 2.389-3.31 2.389-3.31-.462-2.848 1.889-2.348 1.889-2.348-.463-2.848 2.39-2.386 2.39-2.386l4.278 5.196c-1.889-4.272 0-6.62 0-6.62l3.777 5.696c2.852 7.583-.964 12.124-.964 12.124l14.223 34.564h14.183v-.039z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear)",
    d: "M226.266 163.309c-11.062-12.008-22.008-26.403-22.008-36.333l35.536-11.278 9.019 12.702c-20.659 6.273-23.164 23.517-22.547 34.909z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFA3B2",
    d: "M200.673 52.346v16.28l-13.258-1.731 6.629-14.55h6.629z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear)",
    d: "M267.236 66.434l-5.203 17.05-5.82-3.925-3.777 22.246 2.852 27.713s-2.505-5.312-29.138 3.079c-8.556 2.694-21.121-3.349-22.393-3.965-.077-.038-.116-.038-.116-.038l.578-2.156 8.403-30.29-5.666-24.518-.039-.077-2.505-.154-11.717-.77 1.426-18.436 13.76-3.31 18.23-2.117s6.822 9.006 12.527 0l19.001 9.699 9.597 9.969z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear)",
    d: "M268.161 25.095h-3.237v6.274h3.237v-6.274z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear)",
    d: "M309.826 45.764c0 .77-.964 1.117-1.465.5-5.666-6.927-17.19-9.583-26.633-10.545-5.164-.54-9.674-.578-12.218-.5-1.194.038-2.197-.963-2.197-2.156l-.115-9.468c0-1.194 1.002-2.156 2.197-2.156 2.582.039 7.13.039 12.333-.539 9.405-.962 20.89-3.618 26.518-10.546.501-.616 1.464-.27 1.464.5l.116 34.91z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear)",
    d: "M270.011 33.255l5.551 18.706h6.899c.655 0 1.195-.539 1.195-1.193V49.42c0-.578-.386-1.078-.964-1.193l-1.58-.308V32.755l-11.101.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear)",
    d: "M281.767 20.9v14.78c-5.165-.54-9.674-.578-12.218-.501-1.195.038-2.197-.962-2.197-2.156l-.116-9.468c0-1.193 1.002-2.155 2.197-2.155 2.544.077 7.092.077 12.334-.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint28_linear)",
    d: "M246.423 21.093c1.812-2.502 0-4.658 0-4.658-4.316 5.004-8.98 4.658-8.98 4.658 2.505-1.425 2.505-2.887 2.505-2.887-1.811 1.424-5.01 1.424-5.01 1.424-4.317.346-4.664 5.388-4.664 5.388l-1.426-.73c-2.158-4.312-5.396-2.888-5.396-2.888-4.664 2.887 3.238 8.968 3.238 8.968l-2.351 2.695c-6.745-5.466-7.169-15.242-7.169-17.205v-.347c-.424.039-.887.078-1.272.04-4.857-.078-8.133-3.311-8.248-5.967-.193-5.042 6.089-8.621 6.089-8.621 6.206-2.54 8.441 4.002 9.096 6.928.193.808.232 1.308.232 1.308.154-.038.308-.077.462-.077h.077c.077 0 .116-.038.116-.038 7.978-1.54 14.8.5 14.8.5 8.981-4.31 11.871-1.077 11.871-1.077 6.36 5.35-3.738 12.432-3.97 12.586z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint29_linear)",
    d: "M223.491 9.16c-.964.231-4.972 1.54-6.36 6.736v-.346c-.424.038-.886.077-1.272.038.116-2.117 1.041-6.39 6.976-7.66.193.809.232 1.31.232 1.31.154 0 .308-.04.424-.078z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC0BF",
    d: "M282.384 37.718s-1.542-1.154-3.084-.77c-1.542.386-1.156 2.31-.771 2.31 0 0-1.156.77 0 1.924 0 0-.771.385.386 1.54l.385.385s-.385.385 0 .77c.386.385 2.313 1.54 3.469.385 1.156-1.155-.385-6.544-.385-6.544z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint30_linear)",
    d: "M217.632 96.608l-13.914 31.984c-.077-.038-.115-.038-.115-.038l.578-2.155 8.402-30.291-5.666-24.518 7.979 1.154 2.736 23.864z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#515151",
    d: "M323.039 16.372l-9.252 2.693.324 1.11 9.252-2.693-.324-1.11zM333.452 28.098h-19.656v1.156h19.656v-1.156zM313.994 37.02l-.406 1.083 9.239 3.465.406-1.083-9.239-3.464z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFA3B2",
    d: "M238.483 42.3l-.038 4.504c-6.051-1.27-8.402-9.93-8.479-10.239 2.197 3.272 6.282 5.004 8.517 5.735z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 420.059,
    x2: 397.009,
    y1: 283.06,
    y2: 312.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D73D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 392.103,
    x2: 409.098,
    y1: 303.973,
    y2: 264.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 455.44,
    x2: 307.436,
    y1: 297.082,
    y2: 297.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3852CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C93F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 77.91,
    x2: 84.075,
    y1: 262.112,
    y2: 299.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D73D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 71.482,
    x2: 46.732,
    y1: 300.969,
    y2: 256.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 192.396,
    x2: 33.731,
    y1: 293.676,
    y2: 290.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3852CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C93F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 95.329,
    x2: 211.465,
    y1: 302.731,
    y2: 302.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 51.321,
    x2: 64.04,
    y1: 148.086,
    y2: 148.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 126.18,
    x2: 129.852,
    y1: 47.138,
    y2: 33.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 105.246,
    x2: 126.263,
    y1: 230.755,
    y2: 216.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7057E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3852CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 395.121,
    x2: 407.84,
    y1: 134.807,
    y2: 134.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 347.224,
    x2: 364.385,
    y1: 229.912,
    y2: 229.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 353.514,
    x2: 375.877,
    y1: 50.736,
    y2: 38.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 130.928,
    x2: 166.756,
    y1: 121.775,
    y2: 121.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 115.626,
    x2: 151.453,
    y1: 130.665,
    y2: 130.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 298.375,
    x2: 338.368,
    y1: 104.296,
    y2: 104.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 176.777,
    x2: 202.341,
    y1: 188.094,
    y2: 188.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657CE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 303.379,
    x2: 316.041,
    y1: 159.492,
    y2: 159.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657CE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 208.326,
    x2: 226.885,
    y1: 242.101,
    y2: 241.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 249.348,
    x2: 262.64,
    y1: 295.618,
    y2: 282.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 264.153,
    x2: 250.235,
    y1: 140.904,
    y2: 236.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 271.104,
    x2: 213.682,
    y1: 238.929,
    y2: 135.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 204.25,
    x2: 248.828,
    y1: 139.512,
    y2: 139.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 217.918,
    x2: 254.456,
    y1: 65.832,
    y2: 132.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D82E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 264.94,
    x2: 268.194,
    y1: 28.226,
    y2: 28.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BA8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3CD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 267.218,
    x2: 309.843,
    y1: 28.318,
    y2: 28.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#627DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 270.002,
    x2: 283.668,
    y1: 42.343,
    y2: 42.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BA8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2147D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 267.218,
    x2: 281.752,
    y1: 28.311,
    y2: 28.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 207.611,
    x2: 252.475,
    y1: 16.782,
    y2: 16.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 215.844,
    x2: 223.506,
    y1: 11.92,
    y2: 11.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 194.719,
    x2: 210.609,
    y1: 145.495,
    y2: 89.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5170FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationCampaigns);
export default __webpack_public_path__ + "static/media/illustration-campaigns.3ba4febe9257d50e801996053ee3d124.svg";
export { ForwardRef as ReactComponent };